<template>
	<div style="background-color: #ffffff;padding-left: 10px;padding-top: 16px;" class="orderlist">
		<!-- 搜索 -->
		<div class="order_search">
			<span class="ddss">订单搜索</span>
			
			<div class="el-input" style="width: 355px;">
				<input type="text"
				  v-model="search_cont"
				  @keyup.enter="getList(1)"
				  autocomplete="off" placeholder="请输入订单编号" class="el-input__inner">
			</div>
			
			<span class="ddss margin-left-30">订单来源</span>
			<el-select v-model="order_source" placeholder="请选择">
				<el-option v-for="s in source" :label="s.label" :value="s.value">
				</el-option>
			</el-select>
		</div>
		<div class="order_search">
			<span class="ddss">订单状态</span>
			<el-select v-model="status_val" placeholder="请选择">
				<el-option v-for="s in status" :label="s.label" :value="s.value">
				</el-option>
			</el-select>
			
			<span class="ddss margin-left-30">订单类型</span>
			<el-select v-model="order_type" placeholder="请选择">
				<el-option v-for="s in type" :label="s.label" :value="s.value">
				</el-option>
			</el-select>

			<span class="ddss margin-left-30">下单时间</span>
			<el-date-picker v-model="date_val" type="datetimerange"
				value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
			</el-date-picker>
		</div>

		<div class="cx" @click="getList(1)">查询</div>
		<div class="dc" @click="export_order()">导出订单</div>

		<!-- 表格 -->
		<el-tabs v-model="first" type="card" style="margin-top: 20px;">
			<el-tab-pane label="订单列表" name="first">
				<el-table v-loading="loading" :data="tableData" ref="tableRef">
					<el-table-column label="订单编号" fixed="left" prop="order_sn" width="250" align="center">
					</el-table-column>
					<el-table-column prop="partner_oauth" label="商品图" align="center">
						<template slot-scope="scope">
							<div class="imgs_">
								<img :src="scope.row.cover_url"
									style="width: 40px;height: 40px;object-fit: cover;border-radius: 2px;" />
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="商品名" :show-overflow-tooltip="true" width="250" align="center">
						<template slot-scope="scope">
							{{scope.row.title}}
						</template>
					</el-table-column>
					<el-table-column prop="sales_product" label="所属合伙人(社群)" width="150" align="center">
						<template slot-scope="scope">
							<div v-if="scope.row.sell_type == 2">
								<p class="chaochu">{{scope.row.partner_name}}</p>
								<p>({{scope.row.group_name}})</p>
							</div>
							<div v-else>
								<p>--</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="order_amount" label="实付金额" align="center">
					</el-table-column>
					
					<el-table-column prop="type" label="订单类型" width="100" align="center">
					</el-table-column>
					<el-table-column prop="delivery_type_text" label="物流方式" align="center">
					</el-table-column>
					<el-table-column prop="order_time" label="下单时间" width="200" align="center">
					</el-table-column>
					<el-table-column prop="status_text" label="订单状态" align="center">
					</el-table-column>
					<el-table-column width="146px" prop="sub_admin_note" label="品牌商备注" show-overflow-tooltip
						align="center">
					</el-table-column>
					<el-table-column prop="stay_commission" width="161px" fixed="right" label="操作" align="center">
						<template slot-scope="scope">
							<el-button type="text" size="medium"
								v-if="(scope.row.order_status == 1 || scope.row.order_status == 2) && scope.row.delivery_type != 3"
								@click="add_parcel(scope.row.order_sn)">{{scope.row.order_status == 1?'发货':'追加包裹'}}
							</el-button>
							
							<el-button type="text" size="medium"
								v-if="(scope.row.order_status == 1 || scope.row.order_status == 2) && scope.row.delivery_type == 3"
								@click="finish(scope.row.order_sn,scope.$index)">核销完成
							</el-button>
							<el-button type="text" size="medium " @click="go_detail(scope.row.order_sn)">查看</el-button>
							<el-button type="text" size="medium " @click="add_desc(scope.row.id,scope.row.admin_note)">
								备注</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-tab-pane>
		</el-tabs>
		<div class="orderlist_note">
			<el-dialog title="填写备注" :visible.sync="show_desc" :before-close="close_desc" :close-on-click-modal="false">
				<el-input class="gp-textarea" type="textarea" v-model="admin_note" placeholder="请填写备注内容"
					maxlength="200">
				</el-input>
				<div slot="footer">
					<el-button @click="close_desc">取消</el-button>
					<el-button type="primary" @click="send_desc">确定</el-button>
				</div>
			</el-dialog>
		</div>
		<!-- 发货 -->
		<parcel v-if="show_parcel" :show_parcel.sync="show_parcel" :order_sn='Inthe_code' :op_id='op_id'></parcel>
		<!-- 分页器 -->
		<div class="block" style="padding: 40px;background: #ffffff;">
			<el-pagination background align='center' @size-change="handleSizeChange"
				@current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" :pager-count='5'
				layout="total, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>
		
		<settlement :order_sn="Inthe_code" :show="show_settlement" @close="closeSettlement" @success="SettlementSuccess"></settlement>
	</div>
</template>

<script>
	import {
		getDataOrder,
		exportOrder,
		changeNote
	} from '../../api/order';
	import parcel from '@/components/parcel.vue';
	import settlement from '@/components/order/settlement.vue';
	import {
		baseURL,
		noPermissionCode
	} from '@/config'
	export default {
		data() {
			return {
				admin_note: '',
				tableData: [], //列表数据
				currentPage: 1, // 当前页码
				total: 0, // 总条数
				pageSize: 5, // 每页的数据条数
				loading: true,
				options: [{
					value: 'order_code',
					label: '订单编号'
				}, {
					value: 'product_name',
					label: '产品名称'
				}],
				// 订单状态筛选条件 (不限all、待发货1、待收货2、已退款-1、待支付0、已取消-2)
				status: [{
						value: 'all',
						label: '不限'
					},
					{
						value: '1',
						label: '待发货'
					},
					{
						value: '2',
						label: '待收货'
					},
					{
						value: '3',
						label: '已收货'
					},
					{
						value: '-1',
						label: '已退款'
					},
					{
						value: '0',
						label: '待支付'
					},
					{
						value: '-2',
						label: '已取消'
					},
				],
				source: [{
					value: '0',
					label: '全部'
				},{
					value: '1',
					label: '主营订单'
				},{
					value: '2',
					label: '分销订单'
				}],// 订单来源
				order_source: '0',
				type: [{
					value: '0',
					label: '全部'
				},{
					value: '1',
					label: '商品订单'
				},{
					value: '8',
					label: '活动订单'
				}],// 订单类型
				order_type: '0',
				status_val: 'all',
				date_val: '',
				search_cont: '',
				first: 'first',
				show_parcel: false,
				show_desc: false,
				Inthe_code: '',
				Inthe_id: 0,
				op_id: 0,
				show_settlement:false,
				orderIdx:0
			};
		},
		components: {
			parcel,
			settlement
		},
		watch: {
			show_parcel: function(val, oldVal) {
				if (!val) {
					this.op_id = 0;
				}
				this.getList();
			}
		},
		created() {
			let keypage = localStorage.getItem('keypage');
			if (keypage) {
				this.currentPage = parseInt(keypage);
				localStorage.setItem('keypage', '')
			}

			this.getList();
		},
		methods: {
			finish(val,idx){
				this.Inthe_code = val;
				this.show_settlement = true;
				this.orderIdx = idx;
			},
			closeSettlement(val){
				this.show_settlement = false
				if(val){
					this.getList();
				}
			},
			SettlementSuccess(){
				this.show_settlement = false
				this.tableData[this.orderIdx].status_text = '已完成';
				this.tableData[this.orderIdx].order_status = 4;
			},
			close_desc() {
				this.show_desc = false;
			},
			send_desc() {
				var id = this.Inthe_id;
				var admin_note = this.admin_note;
				changeNote({
					order_id: id,
					admin_note: admin_note
				}).then(res => {
					this.show_desc = false;
					if (res.code == 0) {
						this.getList();
						this.$message.success(res.message);
					} else {
						this.$message.error(res.message);
					}
				})
			},
			getList(is_s = 0) {
				if (this.date_val) {
					var s_time = this.date_val[0];
					var e_time = this.date_val[1];
				} else {
					var s_time = '';
					var e_time = '';
				}
				if (is_s) {
					this.currentPage = 1;
				}

				this.loading = true;
				getDataOrder({
					'page': this.currentPage,
					'start_time': s_time,
					'end_time': e_time,
					'order_sn': this.search_cont,
					'status': this.status_val,
					'order_type': this.order_type,
					'order_source': this.order_source,
				}).then(res => {
					if (res.code == 0) {
						this.total = res.data.count;
						this.loading = false;
						this.tableData = res.data.list;
					} else {
						this.$message.error(res.message);
					}
				})
			},
			//每页条数改变时触发 选择一页显示多少行
			handleSizeChange(val) {
				this.currentPage = 1;
				this.pageSize = val;
			},
			//当前页改变时触发 跳转其他页
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getList();
			},
			export_order() {
				if (this.tableData.length < 1) {
					this.$message.error('暂无查询结果，请重新筛选后导出');
					return false;
				}

				if (this.date_val) {
				 var s_time = this.date_val[0];
					var e_time = this.date_val[1];
					var timename = '【' + s_time + '至' + e_time + '】';
				} else {
					var s_time = '';
					var e_time = '';
					var timename = '';
				}
				exportOrder({
					'start_time': s_time,
					'end_time': e_time,
					'order_sn': this.search_cont,
					'status': this.status_val,
					'order_type': this.order_type,
					'order_source': this.order_source,
				}).then(res => {
					const content = res
					const blob = new Blob([content]);
					const fileName = this.$store.getters['user/brandInfo'].full_name + timename + "订单数据.xls";
					if ("download" in document.createElement("a")) {
						// 非IE下载
						const _link = document.createElement("a");
						_link.download = fileName;
						_link.style.display = "none";
						_link.href = URL.createObjectURL(blob);
						document.body.appendChild(_link);
						_link.click();
						URL.revokeObjectURL(_link.href); // 释放URL 对象
						document.body.removeChild(_link);
					} else {
						// IE10+下载
						navigator.msSaveBlob(blob, fileName);
					}
				})
			},
			go_detail(order_sn) {
				this.$router.push({
					path: '/order/detail',
					query: {
						order_sn: order_sn,
						list_page: this.currentPage
					}
				});
			},
			add_desc(id, desc) {
				this.Inthe_id = id;
				this.admin_note = desc;
				this.show_desc = true;
			},
			add_parcel(val) {
				this.Inthe_code = val;
				this.show_parcel = true;
			}
		}
	};
</script>

<style scoped>
	.orderlist_note .el-dialog {
		width: 424px;
	}

	.orderlist_note .gp-textarea textarea {
		height: 100px;
	}

	.orderlist_note .el-dialog__footer {
		padding-top: 20px;
	}

	.father-main {
		overflow: auto;
	}

	/* 	.el-dialog{
		    width: fit-content;
	} */
	body .el-table th.gutter {
		display: table-cell !important;
	}

	body .el-table colgroup.gutter {
		display: table-cell !important;
	}

	.el-table__body {
		/* // 使表格兼容safari，不错位 */
		width: 100%;
		table-layout: fixed !important;
	}

	.order_search {
		height: 40px;
		margin-left: 5px;
		margin-bottom: 16px;
		display: flex;
		align-items: center;
	}
	
	.order_search .el-select {
		width: 150px;
	}

	.ddss {
		margin-right: 10px;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
	}

	.cx {
		width: 102px;
		height: 40px;
		display: inline-block;
		background: #0486FE;
		border-radius: 4px;
		text-align: center;
		line-height: 40px;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #FFFFFF;
		cursor: pointer;
	}

	.dc {
		display: inline-block;
		width: 93px;
		height: 40px;
		background: #FF8700;
		border-radius: 4px;
		text-align: center;
		font-size: 14px;
		font-family: Helvetica;
		color: #FFFFFF;
		line-height: 40px;
		margin-left: 20px;
		cursor: pointer;
	}

	.imgs_ {
		width: 40px;
		height: 40px;
		margin: 0 auto;
		position: relative;
	}

	.bg_img_num {
		width: 40px;
		height: 40px;
		background: rgba(0, 0, 0, 0.5);
		border-radius: 2px;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #FFFFFF;
		text-align: center;
		line-height: 40px;
		position: absolute;
		top: 0;
	}

	.orderlist .el-tabs__header {
		margin: 0;
		margin-top: 20px;
	}

	.chaochu {
		width: 100%;
		/*根据自己项目进行定义宽度*/
		overflow: hidden;
		/*设置超出的部分进行影藏*/
		text-overflow: ellipsis;
		/*设置超出部分使用省略号*/
		white-space: nowrap;
		/*设置为单行*/
	}

	.el-tooltip__popper {
		max-width: 20%;
	}

	.el-tooltip__popper,
	.el-tooltip__popper.is-dark {
		background: rgb(48, 65, 86) !important;
		color: #fff !important;
		line-height: 24px;
	}

	.tipsTxt {
		text-overflow: ellipsis;
		/*设置隐藏部分为省略号*/
		overflow: hidden;
		/*设置隐藏*/
		display: -webkit-box;
		-webkit-line-clamp: 2;
		/*设置显示行数，此处为2行，可设置其他数字*/
		-webkit-box-orient: vertical;
	}
	
	.margin-left-30 {
		margin-left: 30px;
	}
</style>
